import { render } from "./HelpCenterIcon.vue?vue&type=template&id=798773b6"
import script from "./HelpCenterIcon.vue?vue&type=script&lang=js"
export * from "./HelpCenterIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__